module.exports = __webpack_public_path__ + "static/media/starter-semi-circle.63160e75.png";